import React from 'react';
export function ReservationSystem() {
  return <section className="w-full bg-white py-12" data-id="element-158">
      <div className="max-w-6xl mx-auto px-6" data-id="element-159">
        {/* Content indented on desktop, full width on mobile */}
        <div className="lg:pl-[100px]" data-id="element-160">
          {/* Hero heading */}
          <div className="mb-16" data-id="element-161">
            <h1 className="text-3xl font-normal text-[#707070] tracking-wide mb-3" data-id="element-162">
              Rezervační systém
            </h1>
            <p className="text-lg text-[#999] font-light" data-id="element-163">
              Spojování lidí, prostoru a technologií
            </p>
          </div>

          {/* Content blocks */}
          <div className="space-y-16" data-id="element-164">
            {/* Block 1 - Intro with image */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-165">
              <div className="space-y-6" data-id="element-166">
                <p className="text-[#707070] leading-relaxed" data-id="element-167">
                  Vždy najdete včas tu správnou jednací místnost. Díky řešení
                  pro plánování, rezervace a správu systému Crestron.
                </p>
                <p className="text-[#707070] leading-relaxed" data-id="element-168">
                  SW pro správu AV techniky a propojení s kalendářem, vyhledání
                  vhodné místnosti podle kritérií a rezervace, naplánování
                  konferenčního hovoru, vyhledání místnosti. K tomu diagnostika
                  a analytické výstupy.
                </p>
              </div>
              <div className="w-full" data-id="element-169">
                <img src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&h=500&fit=crop&auto=format&q=80" alt="Moderní jednací místnost s rezervačním systémem" className="w-full h-auto grayscale" data-id="element-170" />
              </div>
            </div>

            {/* Block 2 - LCD panels */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-171">
              <div className="w-full lg:order-1" data-id="element-172">
                <img src="https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=800&h=500&fit=crop&auto=format&q=80" alt="LCD panel u dveří jednací místnosti" className="w-full h-auto grayscale" data-id="element-173" />
              </div>
              <div className="space-y-6 lg:order-2" data-id="element-174">
                <p className="text-[#707070] leading-relaxed" data-id="element-175">
                  Díky nástěnným LCD panelů se signalizací stavu místnosti je
                  snadné vždy najít volnou místnost.
                </p>
                <p className="text-[#707070] leading-relaxed" data-id="element-176">
                  Čidla obsazenosti navíc umožňují další funkce, které jiné
                  systémy nenabízí.
                </p>
              </div>
            </div>

            {/* Block 3 - Complex solution */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-177">
              <div className="space-y-6" data-id="element-178">
                <p className="text-[#707070] leading-relaxed" data-id="element-179">
                  Komplexní řešení, navíc propojené s dalšími částmi systému
                  Crestron, přináší maximální efektivitu řešení.
                </p>
                <p className="text-[#707070] leading-relaxed text-lg font-light" data-id="element-180">
                  Nechte si od nás navrhnout celé řešení, a dostanete to
                  nejlepší.
                </p>
              </div>
              <div className="w-full" data-id="element-181">
                <img src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=800&h=500&fit=crop&auto=format&q=80" alt="Komplexní AV řešení v konferenční místnosti" className="w-full h-auto grayscale" data-id="element-182" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}